import {
    EditableFormField,
    PrefilledFormField
} from '@containers/form-i9/styles';
import { DatePicker } from '@material-ui/pickers';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';
import { DateFormatTemplate } from '@utils/date-format';
import { getCurrentISOTimestamp } from '@utils/date-query';
import moment from 'moment';
import * as React from 'react';

export const renderPrefilledField = (fieldText: string) => (
    <PrefilledFormField constrainToParent={true}>
        {fieldText}
    </PrefilledFormField>
);

export function renderPotentiallyEditableField(
    isEditable: boolean,
    onChange: (value: any) => void,
    onBlur?: () => void,
    exampleLabel?: string,
    example?: string | null
) {
    return (text: string, placeholder: string, value?: string) => {
        if (isEditable) {
            return (
                <React.Fragment>
<EditableFormField value={value}
                                   constrainToParent={true}
                                   placeholder={placeholder}
                                   onChange={event => onChange(event.target.value)}
                                   onBlur={onBlur}
                />
                { example !== undefined && example !== null && <p>{exampleLabel}{example}</p> }
                </React.Fragment>
                
            );
        }

        return renderPrefilledField(text);
    };
}

export function renderPotentiallyEditableExpiryDateField(
    isEditable: boolean,
    onChange: (value: string | null) => void,
    minimumDate?: ParsableDate
) {
    // sufficiently far maximum date to not give issues
    const maximumExpiryDate = (
        moment(getCurrentISOTimestamp())
            .startOf('day')
            .add(100, 'year')
            .toISOString()
    );

    return (text: string, placeholder: string, value?: string | null, hasError?: boolean) => {
        if (isEditable) {
            return (
                <DatePicker value={value}
                            inputVariant={'outlined'}
                            format={DateFormatTemplate.MonthFirstCalendarDate}
                            placeholder={placeholder}
                            error={hasError}
                            minDate={minimumDate === null ? undefined : minimumDate}
                            maxDate={maximumExpiryDate}
                            onChange={date => onChange(date?.toISOString() ?? null)}/>
            );
        }

        return renderPrefilledField(text);
    };
}



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/field-content.tsx